var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfertohospital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 0 360 360",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 307V197a10 10 0 0 1 10-10h40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 307h48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 307v-56a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 187h39a10 10 0 0 1 10 10v110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 307h49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 307v-56a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 307V108a25 25 0 0 1 25-25h36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 83h35a25 25 0 0 1 25 25v199"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 83,
    r: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 64v38M162 83h38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 133,
    width: 41,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 133,
    width: 41,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 183,
    width: 41,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 183,
    width: 41,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 307V235h51v72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 307h263"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfertohospital);
export default __webpack_public_path__ + "static/media/transfertohospital.e58c66ee9d349cb9487d9596a2e09a3e.svg";
export { ForwardRef as ReactComponent };